<template>
  <div>

    <br>
        <div class="row">
          <div class="" v-if="selecionados.length || titulo">
          <div>

            <SGPFormBotaoComponent
              class="pa-5"
              color="primary"
              @click="deletarSelecionado"
              v-if="selecionados.length > 1 && usuarioPodeExcluir"
              small
            >
              <v-icon class="mr-3" medium>mdi-format-list-checks</v-icon> Deletar selecionados
            </SGPFormBotaoComponent>

            <SGPFormBotaoComponent
              class="ml-3"
              fab
              rounded
              color="success"
              @click="editarItem(item)"
              v-if="selecionados.length && usuarioPodeExportar"
              small
            >
              <v-icon color="white" small>mdi-file</v-icon>
            </SGPFormBotaoComponent>

          </div>

          <span class="h4" v-if="titulo"> {{ titulo }}</span>

        </div>


        <SGPRowComponent no-gutters >

          <SGPColComponent cols="3" v-if="filtroText">
              <SGPFormInputComponent
                type="text"
                v-model="filter"
                placeholder="Buscar..."
                append-icon="mdi-magnify"
                outlined
                dense
              />
          </SGPColComponent>

          <SGPColComponent cols="12" class="table-wrapper">        
            <v-data-table
              :headers="sanitizaColunas()"
              :items="dados"
              :show-select="!somenteLeitura"
              color="primary"
              :fixed-header="headerFixo"
              :height="headerFixo ? heightFixo : ''"
              v-model="selecionados"
              :hide-default-header="esconderHeader"
              :hide-default-footer="!esconderFooter"
              :class="`${(showExpand) ? 'table_subnivel elevation-4':'main-table-component elevation-0 mt-4'} ${customClass}`"
              item-class="bg-error"
              disable-pagination
              :search="filter"
              item-key="id"
              ref="responsiveTable"
              :single-expand="singleExpand"
              expanded-button="text-red"
              :show-expand="showExpand"
              :expanded="expanded"
              v-bind="$attrs"
            >
              <!-- Expanded Item-->
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="tabela_detalhe_td">
                  <v-data-table
                    :headers="colunasDetalhe"
                    :items="item.detalhe"
                    hide-default-header
                    hide-default-footer
                    class="table_subnivel_detalhe"
                    :calculateWidths="true"
                  >
                  </v-data-table>
                </td>
              </template>
              <!-- -->
              
              <!-- Slot genérico para tooltip em todas as colunas de texto -->
              <template v-for="coluna in colunas" v-slot:[`item.${coluna.key}`]="{ item }">
                <div :key="coluna.key" v-if="!['selecionar', 'containerBotoes', 'imageModal', 'visualizar', 'visualizar_modal', 'associar', 'redirecionar', 'restaurar', 'vincular', 'botao_generico', 'modalGenerica', 'interrompida', 'dentro_sla', 'numero_rec_contrato', 'centro_funcional'].includes(coluna.key)">
                  <SGPTextTooltipComponent :texto="getNestedValue(item, coluna.key)" />
                </div>
                <slot v-else :name="`item.${coluna.key}`" :item="item"></slot>
              </template>
              
              <!-- Modal Image-->
              <template v-slot:item.imageModal="{ item }">
                <SGPFormBotaoComponent
                  class="ml-3"
                  fab
                  rounded
                  color="warning"
                  @click="emissorDeEventoCustomizado(item)"
                  x-small
                  :disabled="!item.imageModal"
                >
                  <v-icon color="white" medium>mdi-file-image</v-icon>
                </SGPFormBotaoComponent>
              </template>

              <!-- <template #cell(visualizar)="row"> -->
              <template v-slot:item.visualizar="{ item }">
                <SGPFormBotaoComponent
                  fab
                  rounded
                  color="warning"
                  :to="item.visualizar"
                  x-small
                >
                  <v-icon color="white" small>mdi-eye</v-icon>
                </SGPFormBotaoComponent>
              </template>

              <template v-slot:item.visualizar_modal="{ item }">
                <SGPFormBotaoComponent
                  fab
                  rounded
                  color="warning"
                  @click="emissorDeEventoCustomizado(item)"
                  x-small
                >
                  <v-icon color="white" small>mdi-eye-outline</v-icon>
                </SGPFormBotaoComponent>
              </template>

              <!-- <template #cell(containerBotoes)="row" v-if="botaoInline"> -->
              <template v-slot:item.selecionar="{ item }">
                <div class="container-botao-tabela">
                  <SGPFormBotaoComponent
                    fab
                    rounded
                    color="warning"
                    @click="editarItem(item)"
                    v-if="usuarioPodeEditar"
                    x-small
                    :disabled="item.deleted_at"
                  >
                    <v-icon color="white" small>mdi-pencil</v-icon>
                  </SGPFormBotaoComponent>
                  
                  <SGPFormBotaoComponent
                    class="ml-2"
                    fab
                    rounded
                    color="primary"
                    @click="excluirItem(item)"
                    v-if="usuarioPodeExcluir"
                    x-small
                    :disabled="item.deleted_at"
                  >
                    <v-icon color="white" small>mdi-delete</v-icon>
                  </SGPFormBotaoComponent>
                </div>
              </template>

              <!-- <template #cell(associar)="row"> -->
              <template v-slot:item.associar="{ item }">
                <SGPFormBotaoComponent
                  fab
                  rounded
                  color="warning"
                  :to="item.associar"
                  x-small
                  :disabled="item.deleted_at"
                >
                  <v-icon color="white" small>mdi-link</v-icon>
                </SGPFormBotaoComponent>
              </template>

              <!-- <template #cell(redirecionar)="row"> -->
              <template v-slot:item.redirecionar="{ item }">
                <SGPFormBotaoComponent
                  fab
                  rounded
                  color="warning"
                  :to="item.redirecionar"
                  x-small
                  :disabled="item.deleted_at"
                >
                  <v-icon color="white" small>mdi-link</v-icon>
                </SGPFormBotaoComponent>
              </template>

              <!-- <template #cell(restaurar)="row" > -->
              <template v-slot:item.restaurar="{ item }">
                <SGPFormBotaoComponent
                  fab
                  rounded
                  color="black"
                  @click="restaurarSelecionado(item)"
                  :disabled="!item.deleted_at"
                  x-small
                >
                  <v-icon color="white" small>mdi-backup-restore</v-icon>
                </SGPFormBotaoComponent>
              </template>

                <template v-slot:item.vincular="{ item }">
                <SGPFormBotaoComponent
                  fab
                  rounded
                  color="warning"
                  @click="vincularSelecionado(item)"
                  :disabled="item.possuiTarefaVinculada"
                  x-small
                >
                  <v-icon color="white" small>mdi-link</v-icon>
                </SGPFormBotaoComponent>
              </template>

              <template v-slot:item.botao_generico="{ item }">
                <SGPFormBotaoComponent
                  v-if="item.botao_generico != null"
                  fab
                  rounded
                  color="black"
                  @click="emissorDeEventoBtnGenerico(item.botao_generico)"
                  :disabled="!item.botao_generico"
                  x-small
                >
                <v-icon color="white" small>mdi-refresh</v-icon>
                </SGPFormBotaoComponent>
              </template>

              <template v-slot:item.modalGenerica="{ item }">
                <SGPFormBotaoComponent
                  fab
                  rounded
                  color="warning"
                  @click="emissorDeEventoCustomizado(item)"
                  x-small
                  :disabled="!item.modalGenerica && item.deleted_at === (null || undefined)"
                >
                  <v-icon color="white" small>mdi-eye</v-icon>
                </SGPFormBotaoComponent>
              </template>

              <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">        
                <slot :name="scopedSlotName" v-bind="slotData"></slot>
              </template>

            </v-data-table>

          </SGPColComponent>
        </SGPRowComponent>
        </div>

    <div id="top-scroll">
      <div class="scroll"></div>
    </div>

    <!-- <div v-if="false" id="responsive-table"  ref="responsiveTable" class="sgp-table table-responsive">

        <div class="titulo-component-tabela mdn-u-padding--xxs" v-if="selecionados.length || titulo">

          <button
            v-if="selecionados.length === 1 && usuarioPodeEditar && !botaoInline"
            class="btn-rounded-xs mdn-Button--global"
            @click="editarSelecionado"
          >
            <i class="mdn-Icon-editar" />
          </button>

          <button
            v-if="selecionados.length >= 1 && usuarioPodeExcluir"
            class="btn-rounded-xs mdn-Button--primary"
            @click="deletarSelecionado"
          >
            <i class="mdn-Icon-lixeira" />
          </button>

          <button
            v-if="selecionados.length && usuarioPodeExportar"
            class="btn-rounded-xs mdn-Button--global"
            @click="exportarSelecionado"
          >
            <i class="mdn-Icon-link-externo" />
          </button>

          <span class="mdn-Heading mdn-Heading--sm" v-if="titulo"> {{ titulo }}</span>

        </div>

        
        <b-form-input
          v-if="filtroText"
          id="filter-input"
          v-model="filter"
          type="search"
          placeholder="Preencha para pesquisar"
          class="w-50 float-end"          
        />
        

        <b-table
          striped
          hover
          :fields="colunas"
          :items="dados"
          ref="selectableTable"
          label-sort-asc=""
          label-sort-desc=""
          label-sort-clear=""
          :filter="filter"          
        >
    
          <template #cell(redirecionar)="row">
            <router-link
              :to="row.item.redirecionar"
              class="btn-rounded-xs mdn-Button--global"
              tag="button"
            >           
                <i class="mdn-Icon-submenu"></i>
            </router-link>
          </template>

          <template #cell(restaurar)="row" >
            <button 
              v-if="row.item.deleted_at != null"
              @click="restaurarSelecionado(row.item)"
              class="btn-rounded-xs mdn-Button--global"
              v-b-tooltip.top
              title="Restaurar" 
              >
              <i class="mdn-Icon-lixeira"></i>
            </button>
          </template>

          <template #cell(acoes)="row"> 
            <button
              class="btn-rounded-xs mdn-Button--global"
              @click="emissorDeEventoCustomizado(row)"
              :disabled="!row.item"
              v-b-tooltip.top
              title="Iniciar Tratamento" 
            >
              <i class="mdn-Icon-nova-pasta mdn-Icon" />
            </button>

            <button
              class="btn-rounded-xs mdn-Button--global"
              @click="emissorDeEventoCustomizado(row)"
              :disabled="!row.item"
              v-b-tooltip.top
              title="Adotar" 
            >
              <i class="mdn-Icon-entretenimento mdn-Icon" />
            </button>

            <button
              class="btn-rounded-xs mdn-Button--global"
              @click="emissorDeEventoCustomizado(row)"
              :disabled="!row.item"
              v-b-tooltip.top
              title="Devolver" 
            >
              <i class="mdn-Icon-retomada mdn-Icon" />
            </button>
          </template>

          <template #cell(botao_generico)="row">
            <button
              class="btn-rounded-xs mdn-Button--global"
              tag="button"
              @click="emissorDeEventoBtnGenerico(row.item.botao_generico)"
            >           
              <v-icon>mdi-refresh</v-icon>
          </button>
          </template>

          <template #cell(visualizar)="row">
            <router-link
              :to="row.item.visualizar"
              class="btn-rounded-xs mdn-Button--global"
              tag="button"
            >           
              <i class="mdn-Icon-submenu"></i>
            </router-link>
          </template>

          <template #cell(visualizar_aba)="row">
            <button
              class="btn-rounded-xs mdn-Button--global"
              tag="button"
              @click="abrirNovaAba(row.item.visualizar_aba)"
            >           
              <i class="mdn-Icon-submenu"></i>
          </button>
          </template>

          <template #cell(associar)="row">
            <router-link
              :to="row.item.associar"
              class="btn-rounded-xs mdn-Button--global"
              tag="button"
            >           
              <i class="mdn-Icon-submenu"></i>
            </router-link>
          </template>
          
           <template #cell(modalGenerica)="row">
            <button
              class="btn-rounded-xs mdn-Button--global"
              @click="emissorDeEventoCustomizado(row)"
            >
              <i class="mdn-Icon-pip mdn-Icon" />
            </button>
          </template>

          <template #cell(modal)="row">
            <button
              class="btn-rounded-xs mdn-Button--global"
              @click="emissorDeEventoCustomizado(row)"
              :disabled="!row.value"
            >
              <i class="mdn-Icon-pip mdn-Icon" />
            </button>
          </template>

          <template #cell(imageModal)="row">
            <button
              class="btn-rounded-xs mdn-Button--global"
              @click="emissorDeEventoCustomizado(row)"
              :disabled="!row.value"
            >
              <i class="mdn-Icon-imagem mdn-Icon" />
            </button>
          </template>

          <template #cell()="data" v-if="aceitaHtml">
            <span v-html="data.value"></span>
          </template>

          <template #cell(links)="row" >
            <router-link v-for="itemRow in row.item.links" v-bind:key="itemRow.id"
                :to="itemRow.link"
              >
                {{itemRow.titulo}}
              </router-link>
          </template>

          <template #head(selecionar) v-if="!somenteLeitura">
            <div class="mdn-Checkbox mdn-Checkbox--inverse">
              <input class="mdn-Checkbox-input" type="checkbox" @change="gerenciarSelecionarTodos" v-model="selecionarTodos" aria-label="Label" />
              <label class="mdn-Checkbox-label" ></label>
            </div>
          </template>

          <template #cell(selecionar)="row" v-if="!somenteLeitura">
            <div class="mdn-Checkbox" aria-label="checkbox">
              <input class="mdn-Checkbox-input" type="checkbox" v-model="selecionados" :value="row.item" aria-label="Label" />
              <label class="mdn-Checkbox-label" for="i1"></label>
            </div>
          </template>


          <template #cell(containerBotoes)="row" v-if="botaoInline">
            <div class="container-botao-tabela">
              <button
                class="btn-rounded-xs mdn-Button--global"
                @click="editarItem(row.item)"
                v-if="usuarioPodeEditar"
              >
                <i class="mdn-Icon-editar" />
              </button>

              <button
                v-if="usuarioPodeExcluir"
                class="btn-rounded-xs mdn-Button--primary"
                @click="excluirItem(row.item)"
              >
                <i class="mdn-Icon-lixeira" />
              </button>
            </div>
          </template>

        </b-table>

        
    </div> -->
    <SGPConfirmacaoRestauracaoComponent
      v-if="abrirModalRestaurar"
      @sgpCancelarRestauracaoEmit="cancelarRestauracao()"
      @sgpConfirmarRestauracaoEmit="confirmarRestauracao()"
    />
  </div>
</template>

<script>
import SGPRowComponent from './SGPRowComponent.vue'

export default {
  components: { SGPRowComponent },
  name: 'SGPTabelaComponent',

  props: {
    titulo: {
      type: String,
      required: false,
      default: ''
    },
    colunas: {
      type: Array,
      required: true
    },

    colunasDetalhe: {
      type: Array,
      required: false
    },

    dados: {
      type: Array,
      required: true
    },
    somenteLeitura: {
      type: Boolean,
      required: false,
      default: false
    },
    usuarioPodeExcluir: {
      type: Boolean,
      required: false,
      default: true
    },
    usuarioPodeEditar: {
      type: Boolean,
      required: false,
      default: true
    },
    usuarioPodeExportar: {
      type: Boolean,
      required: false,
      default: false
    },

    botaoInline: {
      type: Boolean,
      required: false,
      default: false
    },

    aceitaHtml: {
      type: Boolean,
      required: false,
      default: false
    },

    filtroText: {
      type: Boolean,
      required: false,
      default: false
    },

    textoParaFiltragem: {
      type: String,
      required: false,
      default: ''
    },

    headerFixo: {
      type: Boolean,
      required: false,
      default: false
    },

    heightFixo: {
      type: String,
      required: false,
      default: '500px'
    },

    esconderHeader: {
      type: Boolean,
      required: false,
      default: false
    },

    esconderFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    showExpand: {
      type: Boolean,
      required: false,
      default: false
    },
    customClass : {
      type: String,
      required: false,
      default: ""
    }
  },

  data () {
    return {
      selecionados: [],
      selecionarTodos: false,
      abrirModalRestaurar: false,
      itemRestaurar: null,
      widthTopScroll: '',
      mostrarScrollTop: false,
      singleExpand: true,
      filter: this.textoParaFiltragem || null
    }
  },

  created () {
    this.selecionados = []
    this.itemRestaurar = null

    if(this.botaoInline) {

      const colunaAcoes = {
        key: 'containerBotoes',
        label: 'Ações'
      }

      if(this.colunas[0].key === 'selecionar') {
        const colunaSelecao = this.colunas.shift();
        this.colunas.unshift(colunaSelecao, colunaAcoes);

      } else {
        this.colunas.unshift(colunaAcoes);
      }
    }

    window.addEventListener('resize', this.handleResize);

  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  mounted () {
    // let wrapper1 = document.getElementById('top-scroll');
    // let wrapper2 = document.getElementById('responsive-table');
    // wrapper1.onscroll = function() {
    //   wrapper2.scrollLeft = wrapper1.scrollLeft;
    // };
    // wrapper2.onscroll = function() {
    //   wrapper1.scrollLeft = wrapper2.scrollLeft;
    // };
  },

  computed: {
    fields () {
      return []
    },
    fieldsList () {
      return this.fieldsData
    }
  },

  methods: {
    sanitizaColunas () {
      return this.colunas.map(coluna => {
        if (coluna.key === 'selecionar') {
          coluna.width = '110px'
          coluna.label = 'Ações'
        }
        return {
          ...coluna,
          text: coluna.label,
          value: coluna.key
        }
      })
    },

    abrirNovaAba(url) {
      window.open(url);
    },

    gerenciarSelecionarTodos () {
      if( !this.selecionarTodos ) {
        this.selecionados = []
      }
    },
    editarSelecionado () {
      this.$emit('sgpTabelaEditarSelecionadoEmit');
    },
    restaurarSelecionado (item) {
      this.abrirModalRestaurar = true;
      this.itemRestaurar = item;
    },
    vincularSelecionado (item) {
      this.$emit('sgpTabelaVincularSelecionadoEmit', item);
    },
    deletarSelecionado () {
      this.$emit('sgpTabelaDeletarSelecionadoEmit');
    },
    exportarSelecionado () {
      this.$emit('sgpTabelaExportarSelecionadoEmit');
    },
    editarItem (item) {
      this.selecionados = [ item ]
      setTimeout( () => {
        this.editarSelecionado()
      }, 50)

    },
    excluirItem (item) {
      this.selecionados = [ item ]
      setTimeout( () => {
        this.deletarSelecionado()
      }, 50)
    },
    cancelarRestauracao() {
        this.abrirModalRestaurar = false;
    },
    confirmarRestauracao(){
      this.$emit('sgpTabelaRestaurarSelecionadoEmit', this.itemRestaurar);
      this.abrirModalRestaurar = false;
    },
    
    emissorDeEventoCustomizado (item) {
      const itemData = item.item ? item.item : item
      this.$emit('sgpTabelaModalCadastrarEmit', itemData);
    },

    emissorDeEventoBtnGenerico(val) {
      this.$emit('executarEventoBtnGenericoEmit', val);
    },

    handleResize () {
      const tableWidth = this.$refs['responsiveTable'].getElementsByTagName('table')[0].clientWidth

      const scrollTopW = document.getElementsByClassName('scroll')[0].style.width

      document.getElementsByClassName('scroll')[0].style.width = `${tableWidth}px`

      if (tableWidth > scrollTopW) {
        this.mostrarScrollTop = true
      }
      this.widthTopScroll = tableWidth      
    },

    getNestedValue(obj, path) {
      if (!obj || !path) return '-';
      
      const keys = path.split('.');
      let value = obj;
      
      for (let key of keys) {
        if (value && typeof value === 'object') {
          value = value[key];
        } else {
          return '-';
        }
      }
      
      return value !== null && value !== undefined ? value : '-';
    }
  },

  watch: {
    selecionarTodos () {
       this.selecionarTodos ? this.selecionados = this.dados : ''
    },

    selecionados (val) {
      this.$emit('sgpTabelaLinhasSelecionadasEmit', val)

      if (this.selecionados !== this.dados ) {
        this.selecionarTodos = false
      }
    },

    dados: function() {
      // this.$refs.selectableTable.refresh();
      this.selecionados = [];
      this.itemRestaurar = null;
    },

  }
}
</script>

<style lang="scss">

$redColor: #df323b;

#top-scroll, .table-responsive { width: 100%; max-width: 100%; overflow-x: auto; overflow-y:hidden; }
#top-scroll { height: 14px; }

.scroll { width: 100%; height: 20px; background-color: #fff;}
.table-responsive .table { width: 100%; max-width: 100%; overflow-x: auto; }

#top-scroll {
  margin-bottom: 4px;

  scrollbar-color: #D4AA70 #e4e4e4;

  &::-webkit-scrollbar {
      background-image: linear-gradient(00deg, #fff 2%, #fff 2%);
      box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
      border-radius: 0px;
      height: 12px;
  }

  &::-webkit-scrollbar-track {
    margin-top: 20px;
    background-color: #fff;
  }
    
  &::-webkit-scrollbar-thumb {
      border-radius: 100px;
      border: 2px solid rgba(0, 0, 0, 0.56);
      border-left: 0;
      border-right: 0;
      background-color: rgba(50, 50, 50, 1);
  }
}

.main-table-component {
  overflow-x: auto;
  
  thead th {
    background-color: $redColor;
    padding: 12px 8px !important;
    white-space: nowrap;
    min-width: 100px;

    span { 
      font-size: 13px;
      color: #F8F8F8;
      word-break: keep-all;
      font-weight: 600;
    }

    .v-input--selection-controls__input i {
      color: #f8f8f8;
    }
  }

  tbody td {
    padding: 12px 8px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
    font-size: 13px;
    
    &:first-child {
      min-width: 100px;
    }
  }

  tr {
    height: auto;
  }
}

.tabela_detalhe_td {
  background-color: #eee;
  padding: 0 10px 0 58px !important;
}

.table_subnivel {
  overflow-x: auto;
  
  .v-data-table__expand-icon {
    background-color: $redColor;
    border-radius: 50%;
    color: #fff !important;
  }

  thead th {
    background-color: $redColor;
    padding: 12px 8px !important;
    white-space: nowrap;
    min-width: 100px;
    
    &:first-child { border-radius: 4px 0 0 0 }
    &:last-child { border-radius: 0 4px 0 0 }

    span { 
      font-size: 13px;
      color: #F8F8F8;
      word-break: keep-all;
      font-weight: 600;
    }
  }

  tbody td {
    padding: 12px 8px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
    font-size: 13px;
  }

  tbody tr:last-child td {
    &:first-child { border-radius: 0 0 0 4px }
    &:last-child { border-radius: 0 0 4px 0 }
  }
}

.table_subnivel_detalhe tbody tr td {
  background-color: #eee !important;
  font-weight: 500 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

// Scrollbar styling para melhor visualização
.main-table-component::-webkit-scrollbar,
.table_subnivel::-webkit-scrollbar {
  height: 8px;
}

.main-table-component::-webkit-scrollbar-track,
.table_subnivel::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.main-table-component::-webkit-scrollbar-thumb,
.table_subnivel::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
  
  &:hover {
    background: #555;
  }
}

// Wrapper para tabela responsiva
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  
  .v-data-table {
    min-width: 100%;
  }
}

</style>
